import type { Key } from '#/types';
import { hasTypedKey } from './typeGuards';

const deepMapChildren = <T, K extends Key<T>>(
  items: T[],
  walk: (item: T) => T,
  childrenKey = 'items' as K,
): T[] => {
  return items.map((item) => {
    const newItem = {
      ...item,
    };
    if (hasTypedKey(item, childrenKey, 'array')) {
      newItem[childrenKey] = deepMapChildren(item[childrenKey] as T[], walk, childrenKey) as T[K];
    }

    const result = walk(newItem);

    return result;
  });
};

export default deepMapChildren;
